import { produce } from "immer";

export const actions = (set, get) => ({
    setSelectedViewTypeId: (viewTypeId) => {
        set(produce(state => {
            const module = state[get().selectedModule];
            module.viewTypeId = viewTypeId;
        }), false, 'setSelectedViewTypeId');
    },
    setSelectedOffice: (office) => {
        set(produce(state => {
            const module = state[get().selectedModule];
            module.selectedOffice = office;
        }), false, 'setSelectedOffice');
    },
});
